import React, { useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { IMPERSONATE_LINK } from '../../utils/Endpoints';

interface ImpersonateEyeProps {
    id: number;
    isEnabled?: boolean;
    classes?: string;
}

export function ImpersonateEye({ id, classes = 'btn-icon', isEnabled = true }: ImpersonateEyeProps) {
    const [isImpersonating, setIsImpersonating] = useState(false);
    const authToken = localStorage.getItem('token');
    const location = useLocation();
    const currentRoute = location.pathname;

    const handleImpersonate = async () => {
        setIsImpersonating(true);
        setTimeout(() => {
            const redirectUrl = `${IMPERSONATE_LINK}/impersonate/${authToken}/${id}/true${currentRoute}`;
            window.location.replace(redirectUrl);
        }, 500);
    };

    return (
        <>
            {isEnabled && (
                <button className={`btn ${classes}`} onClick={handleImpersonate}>
                    <FaEye className="cursor-pointer mx-2" />
                </button>
            )}

            {isImpersonating && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: 'white',
                        fontSize: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                    }}
                >
                    Impersonating... <strong style={{ marginLeft: '8px' }}>ID: {id}</strong>
                </div>
            )}
        </>
    );
}
